<template>
  <div
    class="sticky z-50 top-0 w-full bg-gray-600 text-white min-h-10"
  >
    <header class="px-3 py-2 grid grid-cols-2 gap-x-2 items-center">
      <div class="flex flex-row gap-x-5 items-center">
        <img
          @click="handleNavbar"
          src="../../assets/png/breadcrumb.png"
          alt="breadcrumb"
          class="w-5 h-4 cursor-pointer"
        />
        <div>{{title}}</div>
      </div>
      <div class="flex justify-end items-center gap-x-4">
        <div class="flex flex-col text-sm">
          <div class="">Hai, {{me?.name}} !</div>
        </div>
        <div class="md:block hidden">
          <img
            :src="me?.photo ? me?.photo : 'https://picsum.photos/200'"
            alt=""
            class="w-10 rounded-full"
          />
        </div>

        <button @click="handleLogout">
          <img src="../../assets/svg/logout.svg" class="" />
        </button>
      </div>
    </header>
  </div>
</template>
<script>
import { purgeAccessToken, purgeRefreshToken, getMe, purgeMe } from "@/utils/accessToken";

export default {
  name: "Navbar",
  props: {
    handleNavbar: {
      type: Function
    }
  },
  data(){
    return{
      title: '',
      name: '',
      me: {},
    }
  },
  mounted(){
    this.title = this.$route.meta.title
    // console.log('judul', this.title) 
    this.getMe()
  },
  watch: {
    $route() {
      this.title = this.$route.meta.title
    }
  },
  methods: {
    handleLogout() {
      purgeAccessToken()
      purgeRefreshToken()
      purgeMe()
      window.location.reload()
    },
    getMe() {
      this.me = JSON.parse( getMe() )
      // console.log('me', this.me)
    }
  }
};
</script>
<style>
::v-deep(.custom-tooltip .p-tooltip-text) {
    background-color: var(--pink-800);
    color: rgb(255, 255, 255);
    font-size: 0.8rem;
}
::v-deep(.custom-tooltip .p-tooltip-bottom .p-tooltip-arrow) {
    border-right-color: var(--pink-800);
}
</style>